import React from 'react';

import { LoaderContainer, LoaderImage } from './Loader.styles';

export const Loader = ({ fullScreen, className }: { className?: string; fullScreen?: boolean }) => (
  <LoaderContainer fullScreen={fullScreen} className={`loader-container ${className || ''}`}>
    <LoaderImage className="loader-wrapper" />
  </LoaderContainer>
);
